export default function getAttribute(attributeKey, { attributes = [] } = {}) {
  return attributes.find(attribute => attribute.key === attributeKey)?.value;
}
